import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalConfig, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerPartSearchObj } from '../../business-entities/dealer-part-search-object-view-model';
import { DealerPartsListDetails } from '../../business-entities/dealer-parts-list-details-view-model';
import { PartsListViewModel } from '../../business-entities/parts-list-view-model';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DealerPartsService } from '../../business-services/dealer-parts.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { PartsBusinessService } from '../../business-services/parts.service';
import { SettingService } from '../../business-services/setting.service';
import { CultureLocaleService } from '../../services/culture-locale.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { AddDealerPartsComponent } from './add-dealer-parts/add-dealer-parts.component';
import { EditDealerPartsComponent } from './edit-dealer-parts/edit-dealer-parts.component';
import { AdminCommonService } from '../../services/admin-common.service';
@Component({
  selector: 'app-dealer-parts',
  templateUrl: './dealer-parts.component.html'
})
export class DealerPartsComponent implements OnInit, OnDestroy {
  partsList: PartsListViewModel[];
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  selectedPartId: string = '';
  partSelected: string;
  paginationSub: Subscription;
  dealerPartDetails: DealerPartsListDetails[];
  userRoleRightsDetails: UserRoleMenu;
  searchObj: DealerPartSearchObj = {
    partId: 0,
    dealerId: ''
  };
  focus$ = new Subject<string>();
  cost: string = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    public dealerBusinessService: DealerBusinessService,
    private route: ActivatedRoute,
    private partService: PartsBusinessService,
    public dealerPartService: DealerPartsService,
    public settingService: SettingService,
    private userService: UserDataService,
    private cookieservice: CookieService,
    public cultureLocaleService: CultureLocaleService,
    private modalService: NgbModal,
    private adminCommonService: AdminCommonService,
    config: NgbModalConfig
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['partNumber', 'dealerName', 'convertToPartNumber', 'description', 'unitPrice',
      'isActive', 'quantity'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.DealerParts);
    this.pService.dataSource = [];
    this.getUserDealers();
    this.getParts();
    this.route
      .queryParams
      .subscribe(_params => {
        // Defaults to 0 if no query param provided.
        // this.selectedDealerId = params['dealerId'] || '0671FA14-E3F6-4690-8B57-0FA12466F174';
        this.selectedDealerId = '';
      });

    if (this.dealerPartService.dealerId && this.dealerPartService.dealerId != undefined) {
      this.searchObj.dealerId = this.dealerPartService.dealerId;
    }
    this.searchObj.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.dealerPartService.dealerId = this.searchObj.dealerId;
    this.getDealerPartSearch(this.searchObj);
    this.focus$.subscribe(x => {
      if (x.length === 0) {
        this.searchObj.dealerId = '';
        this.getDealerPartSearch(this.searchObj);

      }

    });
    this.selectedDealerId = this.userService.currentUserValue.defaultDealerId;
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerPartService.dealerList = this.dealerList;
      if(this.dealerList.length === 1){
        this.selectedDealerId = this.dealerList[0].value;
      }
    })
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{

        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string) {
    this.selectedDealerId = dealerId;
    this.searchObj.dealerId= dealerId ?? '';
    this.dealerPartService.dealerId = this.searchObj.dealerId;
    this.getDealerPartSearch(this.searchObj);
  }

  formatter = (result: SelectListItemViewModel) => result ? result.text.toUpperCase() : '';

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        return term === '' ? []
          : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
      })
    )

  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();

    this.selectedDealerId = event.item.value;
    this.searchObj.dealerId = this.selectedDealerId;
    this.dealerPartService.dealerId = this.selectedDealerId;
    this.getDealerPartSearch(this.searchObj);

  }
  dealerEmpty() {
    if (this.selectedDealerId === '') {
      this.searchObj.dealerId = '';
    }
  }
  onChange(_event) {
    if (this.selectedDealerId === '') {
      this.searchObj.dealerId = '';
    }
    this.searchObj.partId = +this.partSelected;
    this.getDealerPartSearch(this.searchObj);
  }
  async getParts() {
      this.spinner.show();
      let model = {
        makeCode: "",
        description:  "",
        no:  "",
        languageCode:this.cookieservice.get('userSelectedLanguage'),
        dealerId: this.userService.currentUserValue.defaultDealerId
      }
      await this.partService.getParts(model).then(response => {
        this.partsList = response != null ? response.filter(f => f.isActive) : [];
        this.dealerPartService.partsList = this.partsList;
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });

    }

  async getDealerPartSearch(searchObj: DealerPartSearchObj) {
    this.spinner.show();
    searchObj.languageCode = this.cookieservice.get('userSelectedLanguage')
    await this.dealerPartService.getDealerAndPartSearch(searchObj).then((response:any) => {
      this.pService.dataSource = response;
        this.dealerPartDetails = this.dealerPartDetailsMapping(response);
    })
    this.spinner.hide();
  }
  private dealerPartDetailsMapping(dealerParts: any) {
    let supperArray = [];
    if (dealerParts && dealerParts.length > 0) {

      for (let index = 0; index < dealerParts.length; index++) {
        const element = dealerParts[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.id = element.id;
        single.dealerName = element.dealerName;
        single.dealerId = element.dealerId;
        single.isActive = element.isActive;
        single.unitPrice = element.unitPrice;
        single.description = element.description;
        single.partNumber = element.partNumber;
        single.quantity = element.quantity;
        single.remainingQuantity = element.remainingQuantity;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onAdd() {
    const modalref = this.modalService.open(AddDealerPartsComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
 
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  editPartsDetails(id: number) {
    this.dealerPartService.dealerId = this.searchObj.dealerId;
    this.dealerPartService.dealerPartId = id;
    const modalref = this.modalService.open(EditDealerPartsComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }


}
